import { startMagnetPull, stopMagnetPull } from './magnet.js';
import { config, guiInstance } from './config.js';

let moveJoystickActive = false;
let moveJoystickTouchId = null;
let moveJoystickCenterX = 0;
let moveJoystickCenterY = 0;

export let touchMoveX = 0;
export let touchMoveY = 0;

let lookJoystickActive = false;
let lookJoystickTouchId = null;
let lookJoystickCenterX = 0;
let lookJoystickCenterY = 0;

export let touchLookX = 0;
export let touchLookY = 0;
let targetTouchLookX = 0;
let targetTouchLookY = 0;

export let touchTargetX = 0;
export let touchTargetY = 0;

let moveJoystickVisual = null;
let moveJoystickKnob = null;
let lookJoystickVisual = null;
let lookJoystickKnob = null;

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export function isMobileDevice() {
    return isMobile;
}

export function initMobileControls(playerBody, playerStart, fireProjectile) {
    if (!isMobile) return;

    createJoystickVisuals();
    createMobileUI(playerBody, playerStart, fireProjectile);
}

function createJoystickVisuals() {
    moveJoystickVisual = document.createElement('div');
    moveJoystickVisual.style.cssText = `
        position: fixed;
        width: 140px;
        height: 140px;
        border: 1px solid rgba(100, 150, 255, 0.5);
        border-radius: 50%;
        pointer-events: none;
        display: none;
        z-index: 999;
    `;
    document.body.appendChild(moveJoystickVisual);

    moveJoystickKnob = document.createElement('div');
    moveJoystickKnob.style.cssText = `
        position: absolute;
        width: 50px;
        height: 50px;
        background: rgba(100, 150, 255, 0.4);
        border: 1px solid rgba(100, 150, 255, 0.7);
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
    `;
    moveJoystickVisual.appendChild(moveJoystickKnob);

    lookJoystickVisual = document.createElement('div');
    lookJoystickVisual.style.cssText = `
        position: fixed;
        width: 140px;
        height: 140px;
        border: 1px solid rgba(255, 150, 100, 0.5);
        border-radius: 50%;
        pointer-events: none;
        display: none;
        z-index: 999;
    `;
    document.body.appendChild(lookJoystickVisual);

    lookJoystickKnob = document.createElement('div');
    lookJoystickKnob.style.cssText = `
        position: absolute;
        width: 50px;
        height: 50px;
        background: rgba(255, 150, 100, 0.4);
        border: 1px solid rgba(255, 150, 100, 0.7);
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
    `;
    lookJoystickVisual.appendChild(lookJoystickKnob);
}

function calculateEaseCurve(normalizedDistance) {
    const curveType = config.mobile.joystickCurve;
    const power = config.mobile.joystickPower;
    
    if (curveType === 'bell') {
        const peak = 0.7;
        if (normalizedDistance < peak) {
            return Math.pow(normalizedDistance / peak, power);
        } else {
            const decay = (normalizedDistance - peak) / (1 - peak);
            return 1 - Math.pow(decay, 2) * 0.3;
        }
    } else if (curveType === 'linear') {
        return normalizedDistance;
    } else {
        return Math.pow(normalizedDistance, power);
    }
}

function createMobileUI(playerBody, playerStart, fireProjectile) {
    const topRightControls = document.createElement('div');
    topRightControls.className = 'mobile-controls-top-right';

    const settingsBtn = document.createElement('div');
    settingsBtn.className = 'mobile-btn';
    settingsBtn.textContent = 'S';
    topRightControls.appendChild(settingsBtn);

    const resetBtn = document.createElement('div');
    resetBtn.className = 'mobile-btn';
    resetBtn.textContent = 'R';
    topRightControls.appendChild(resetBtn);

    document.body.appendChild(topRightControls);

    const hudLeftBtn = document.createElement('div');
    hudLeftBtn.className = 'mobile-btn-hud mobile-btn-hud-left';
    hudLeftBtn.textContent = '●';
    document.body.appendChild(hudLeftBtn);

    const hudRightBtn = document.createElement('div');
    hudRightBtn.className = 'mobile-btn-hud mobile-btn-hud-right';
    hudRightBtn.textContent = 'M';
    document.body.appendChild(hudRightBtn);

    const moveJoystickZone = document.createElement('div');
    moveJoystickZone.className = 'joystick-zone-left';
    document.body.appendChild(moveJoystickZone);

    const lookJoystickZone = document.createElement('div');
    lookJoystickZone.className = 'joystick-zone-right';
    document.body.appendChild(lookJoystickZone);

    settingsBtn.addEventListener('touchstart', (e) => {
        e.preventDefault();
        if (guiInstance) {
            const isVisible = !guiInstance._hidden;
            if (isVisible) {
                guiInstance.hide();
            } else {
                guiInstance.show();
            }
        }
        settingsBtn.classList.add('active');
        setTimeout(() => settingsBtn.classList.remove('active'), 200);
    });

    hudRightBtn.addEventListener('touchstart', (e) => {
        e.preventDefault();
        if (config.magnet.enabled) {
            startMagnetPull();
            hudRightBtn.classList.add('active');
        }
    });
    hudRightBtn.addEventListener('touchend', (e) => {
        e.preventDefault();
        if (config.magnet.enabled) {
            stopMagnetPull();
            hudRightBtn.classList.remove('active');
        }
    });

    resetBtn.addEventListener('touchstart', (e) => {
        e.preventDefault();
        playerBody.setTranslation(playerStart, true);
        playerBody.setLinvel({ x: 0, y: 0, z: 0 }, true);
        resetBtn.classList.add('active');
        setTimeout(() => resetBtn.classList.remove('active'), 200);
    });

    hudLeftBtn.addEventListener('touchstart', (e) => {
        e.preventDefault();
        fireProjectile();
        hudLeftBtn.classList.add('active');
        setTimeout(() => hudLeftBtn.classList.remove('active'), 200);
    });

    moveJoystickZone.addEventListener('touchstart', (e) => {
        e.preventDefault();
        if (moveJoystickActive) return;
        
        const touch = e.changedTouches[0];
        moveJoystickTouchId = touch.identifier;
        moveJoystickActive = true;
        moveJoystickCenterX = touch.clientX;
        moveJoystickCenterY = touch.clientY;
        
        moveJoystickVisual.style.display = 'block';
        moveJoystickVisual.style.left = (moveJoystickCenterX - 70) + 'px';
        moveJoystickVisual.style.top = (moveJoystickCenterY - 70) + 'px';
    });

    moveJoystickZone.addEventListener('touchmove', (e) => {
        e.preventDefault();
        if (!moveJoystickActive) return;
        
        for (let i = 0; i < e.changedTouches.length; i++) {
            const touch = e.changedTouches[i];
            if (touch.identifier === moveJoystickTouchId) {
                const deltaX = touch.clientX - moveJoystickCenterX;
                const deltaY = touch.clientY - moveJoystickCenterY;
                
                const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                const maxDistance = 70;
                
                let clampedDeltaX = deltaX;
                let clampedDeltaY = deltaY;
                
                if (distance > maxDistance) {
                    clampedDeltaX = (deltaX / distance) * maxDistance;
                    clampedDeltaY = (deltaY / distance) * maxDistance;
                }
                
                const normalizedDistance = Math.min(distance / maxDistance, 1.0);
                const easeMultiplier = calculateEaseCurve(normalizedDistance);
                
                touchMoveX = (clampedDeltaX / maxDistance) * easeMultiplier * config.mobile.moveSensitivity;
                touchMoveY = -(clampedDeltaY / maxDistance) * easeMultiplier * config.mobile.moveSensitivity;
                
                moveJoystickKnob.style.transform = `translate(calc(-50% + ${clampedDeltaX}px), calc(-50% + ${clampedDeltaY}px))`;
                break;
            }
        }
    });

    moveJoystickZone.addEventListener('touchend', (e) => {
        e.preventDefault();
        
        for (let i = 0; i < e.changedTouches.length; i++) {
            const touch = e.changedTouches[i];
            if (touch.identifier === moveJoystickTouchId) {
                moveJoystickActive = false;
                moveJoystickTouchId = null;
                touchMoveX = 0;
                touchMoveY = 0;
                
                moveJoystickVisual.style.display = 'none';
                moveJoystickKnob.style.transform = 'translate(-50%, -50%)';
                break;
            }
        }
    });

    lookJoystickZone.addEventListener('touchstart', (e) => {
        e.preventDefault();
        if (lookJoystickActive) return;
        
        const touch = e.changedTouches[0];
        lookJoystickTouchId = touch.identifier;
        lookJoystickActive = true;
        lookJoystickCenterX = touch.clientX;
        lookJoystickCenterY = touch.clientY;
        
        lookJoystickVisual.style.display = 'block';
        lookJoystickVisual.style.left = (lookJoystickCenterX - 70) + 'px';
        lookJoystickVisual.style.top = (lookJoystickCenterY - 70) + 'px';
    });

    lookJoystickZone.addEventListener('touchmove', (e) => {
        e.preventDefault();
        if (!lookJoystickActive) return;
        
        for (let i = 0; i < e.changedTouches.length; i++) {
            const touch = e.changedTouches[i];
            if (touch.identifier === lookJoystickTouchId) {
                const deltaX = touch.clientX - lookJoystickCenterX;
                const deltaY = touch.clientY - lookJoystickCenterY;
                
                const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                const maxDistance = 70;
                
                let clampedDeltaX = deltaX;
                let clampedDeltaY = deltaY;
                
                if (distance > maxDistance) {
                    clampedDeltaX = (deltaX / distance) * maxDistance;
                    clampedDeltaY = (deltaY / distance) * maxDistance;
                }
                
                const normalizedX = clampedDeltaX / maxDistance;
                const normalizedY = clampedDeltaY / maxDistance;
                
                const normalizedDistance = Math.min(distance / maxDistance, 1.0);
                const easeMultiplier = calculateEaseCurve(normalizedDistance);
                
                const yawMult = config.mobile.invertYaw ? 1 : -1;
                const pitchMult = config.mobile.invertPitch ? 1 : -1;
                
                targetTouchLookX += normalizedX * 0.025 * config.mobile.lookSensitivity * easeMultiplier * yawMult;
                targetTouchLookY += normalizedY * 0.025 * config.mobile.lookSensitivity * easeMultiplier * pitchMult;
                
                targetTouchLookY = Math.max(-Math.PI / 3, Math.min(Math.PI / 3, targetTouchLookY));
                
                lookJoystickKnob.style.transform = `translate(calc(-50% + ${clampedDeltaX}px), calc(-50% + ${clampedDeltaY}px))`;
                
                touchTargetX = (touch.clientX / window.innerWidth) * 2 - 1;
                touchTargetY = -(touch.clientY / window.innerHeight) * 2 + 1;
                break;
            }
        }
    });

    lookJoystickZone.addEventListener('touchend', (e) => {
        e.preventDefault();
        
        for (let i = 0; i < e.changedTouches.length; i++) {
            const touch = e.changedTouches[i];
            if (touch.identifier === lookJoystickTouchId) {
                lookJoystickActive = false;
                lookJoystickTouchId = null;
                
                if (config.mobile.autoReturnPitch) {
                    targetTouchLookY = 0;
                }
                
                lookJoystickVisual.style.display = 'none';
                lookJoystickKnob.style.transform = 'translate(-50%, -50%)';
                break;
            }
        }
    });

    document.addEventListener('touchcancel', (e) => {
        for (let i = 0; i < e.changedTouches.length; i++) {
            const touch = e.changedTouches[i];
            
            if (touch.identifier === moveJoystickTouchId) {
                moveJoystickActive = false;
                moveJoystickTouchId = null;
                touchMoveX = 0;
                touchMoveY = 0;
                moveJoystickVisual.style.display = 'none';
                moveJoystickKnob.style.transform = 'translate(-50%, -50%)';
            }
            
            if (touch.identifier === lookJoystickTouchId) {
                lookJoystickActive = false;
                lookJoystickTouchId = null;
                if (config.mobile.autoReturnPitch) {
                    targetTouchLookY = 0;
                }
                lookJoystickVisual.style.display = 'none';
                lookJoystickKnob.style.transform = 'translate(-50%, -50%)';
            }
        }
    });
}

export function updateMobileControls(dt) {
    if (!isMobile) return;
    
    const lookEase = 0.08;
    touchLookX += (targetTouchLookX - touchLookX) * lookEase;
    touchLookY += (targetTouchLookY - touchLookY) * lookEase;
}

export function getMobileMovement() {
    return { x: touchMoveX, y: touchMoveY };
}

export function getMobileLook() {
    return { x: touchLookX, y: touchLookY };
}

export function getMobileRaycast() {
    return { x: touchTargetX, y: touchTargetY };
}